import { createAsyncThunk } from '@reduxjs/toolkit';

import { BackrsUser, handleAutoLogin } from '@backrs_ui/common-ui';

import { getBackrsToken } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL;

export const fetchUserViaAutoLogin = createAsyncThunk(
  'user/fetchUserViaAutoLogin',
  async (_, { rejectWithValue }) => {
    try {
      if (!ENVIRONMENT_URL) {
        return rejectWithValue('No environment URL found');
      }

      const accessToken = getBackrsToken();

      if (!accessToken) {
        return null;
      }

      const backrsUser = await handleAutoLogin(accessToken, ENVIRONMENT_URL);

      if (!backrsUser) {
        return null;
      }

      const catchUpCount = await fetch(`${ENVIRONMENT_URL}/user-feed/catchup-unread-count`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      const catchUpCountJson: { count: number } = await catchUpCount.json();

      const backrsUserWithCatchUpCount: BackrsUser = {
        ...backrsUser,
        catch_up_count: catchUpCountJson.count,
      };

      return backrsUserWithCatchUpCount;
    } catch (error) {
      return rejectWithValue(`Failed to fetch career questions with error: ${error}`);
    }
  },
);
